import Analytics from "../components/Analytics/Analytics";
import {PERM} from "../utilites/permissions";
import WorkersAnalytics from "../components/Analytics/WorkersAnalytics";

const analytics = [
  {
    path: '/analytics',
    name: 'Analytics',
    component: Analytics,
    meta: {requiresAuth: true,
      permissions: [
        PERM.ANALYTIC,
      ]
    },
    props: true,
  },
  {
    path: '/workers_analytics',
    name: 'WorkersAnalytics',
    component: WorkersAnalytics,
    meta: {requiresAuth: true,
      permissions: [
        PERM.ANALYTIC,
      ]
    },
    props: true,
  },

];

export default analytics;



// WEBPACK FOOTER //
// ./src/router/analytics.js